module.exports = __webpack_public_path__ + "img/85.3.TP.16bbcd19.png";